// extracted by mini-css-extract-plugin
export default {"main":"AboutUs_main__Rv+Z+","blue":"AboutUs_blue__rbMkY","section":"AboutUs_section__vMbXy","left":"AboutUs_left__OECmZ","right":"AboutUs_right__csyqr","sign":"AboutUs_sign__3Sm4D"};